import React from "react";
// import { Routes, Route } from "react-router-dom";
import { Routes, Route, HashRouter as Router } from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Test from "./pages/Test.jsx";
import DonationPage from "./pages/DonationPage.jsx";
import StayTune from "./components/StayTune.jsx";

function App() {
  return (
    <div>
      {/* <Router basename={"abc"}></Router> */}
      <Navbar />
      <div>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/donation" element={<DonationPage />} />
          <Route path="/experiance" element={<StayTune />} />
          <Route path="/events" element={<StayTune />} />
          <Route path="/programs" element={<StayTune />} />
          <Route path="/history" element={<StayTune />} />
          <Route path="/books" element={<StayTune />} />
          <Route path="/local-masters" element={<StayTune />} />
          <Route path="/test" element={<Test />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
